module.exports = __webpack_public_path__ + "img/Richard.0a40fad3.jpg";